import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Pattern } from '@app/shared/validators/pattern';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { AddressService } from '@app/shared/services/address/address.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';

@Component({
  selector: 'app-add-address',
  templateUrl: './add-address.component.html',
  styleUrls: ['./add-address.component.css']
})
export class AddAddressComponent implements OnInit {

  addNewAddressForm: FormGroup;
  countries !: any[];
  states !: any[];
  userId: any;
  userRole: any;
  editAddressId !: any;
  isUpdate = false;

  constructor(private formBuilder: FormBuilder, private loader: LoaderService, private notificationService: NotificationService,
    private addressService: AddressService, private dialogRef: MatDialogRef<AddAddressComponent>, private errorhandlerService: ErrorhandlerService,
    @Inject(MAT_DIALOG_DATA) public data: any) {

    this.userId = localStorage.getItem('userId');

    this.userId = this.userId ? this.userId : this.getGuestId();
    this.addNewAddressForm = this.formBuilder.group({
      Name: new FormControl('', Validators.compose([Validators.required, Validators.pattern(Pattern.STRING_PATTERN)])),
      LastName: new FormControl('', Validators.compose([Validators.required, Validators.pattern(Pattern.STRING_PATTERN)])),
      PhoneNumber: new FormControl('', Validators.compose([Validators.required, Validators.pattern(Pattern.CONTACT_NO_PATTERN),
      Validators.minLength(10), Validators.maxLength(10)])),
      AddressLine: new FormControl('', Validators.required),
      ZipCode: new FormControl('', Validators.compose([Validators.required, Validators.pattern(Pattern.NUMBER_PATTERN),
      Validators.minLength(5), Validators.maxLength(5)])),
      StateId: new FormControl('', Validators.required),
      CountryId: new FormControl('', Validators.required),
      City: new FormControl('', Validators.compose([Validators.required, Validators.pattern(Pattern.STRING_PATTERN)])),
      Landmark: new FormControl(''),
      UserId: new FormControl( this.userId),
      Email: new FormControl('', Validators.compose([Validators.email])),
      AddressId: new FormControl('')
    });
  }

  getGuestId() {
    const guestId = localStorage.getItem('guestId');
    if (guestId) {
      return guestId;
    } else {
      const id = Math.ceil(Math.random() * 100000000);
      localStorage.setItem('guestId', id.toString());
      return id.toString();
    }
  }
  ngOnInit() {
    this.getCountries();
    this.userRole = localStorage.getItem('userRole');
    if (this.data && this.data.addressId) {
      this.editAddressId = this.data.addressId;
        this.isUpdate = true;
        this.fn_GetAddress();
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.addNewAddressForm.controls; }

  /** Function to add address */
  fn_AddNewAddress(form: FormGroup) {
    this.loader.show();
    this.addressService.addAddress(form.value).subscribe((res: any) => {   
      this.loader.hide();      
      if (res.StatusCode === 200) {
        this.notificationService.success(res.Message, 'Success');
        this.dialogRef.close();
      } else {
        this.notificationService.error(res.Message, 'Error');   
      }     
    }, (err: any) => {
      this.loader.hide();
      this.errorhandlerService.handleError(err);
    });
  }

  /** Function to update address */
  fn_UpdateAddress(form: FormGroup) {
    this.loader.show();
    this.addressService.updateAddress(form.value).subscribe((res: any) => {
      this.loader.hide();
      if (res.StatusCode === 200) {
        this.notificationService.success(res.Message, 'Success');
        this.dialogRef.close();
      } else {
        this.notificationService.success(res.Message, 'Error');
      }
    }, (err: any) => {
      this.loader.hide();
      this.errorhandlerService.handleError(err);
    });
  }

  /** Get all countries */
  getCountries() {
    this.addressService.getCountries().subscribe((res: any) => {
      this.countries = res.Data.ResponseData;
    }, err => {
    });
  }

  /** Get states by counktry */
  getStatesByCountry(event: any) {
    if (event !== null && event !== 0) {
      this.loader.show();
      this.addressService.getStatesByCountry(event).subscribe((res: any) => {
        this.states = res.Data.ResponseData;
        this.loader.hide();
      }, err => {
        this.loader.hide();
      });
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

    /** Function to get all address */
    fn_GetAddress() {
      this.loader.show();
      this.addressService.getAddress(this.editAddressId).subscribe((res: any) => {
        this.loader.hide();
        if (res.StatusCode === 200 && res.Data.ResponseData) {
          this.getStatesByCountry(res.Data.ResponseData.CountryId);
          let nameArr = res.Data.ResponseData.Name.split(' ');
          let firstName = nameArr[0];
          let lastName = nameArr[1];
          this.addNewAddressForm.setValue({
            Name: firstName,
            LastName: lastName,
            PhoneNumber : res.Data.ResponseData.PhoneNumber,
            AddressLine: res.Data.ResponseData.AddressLine,
            ZipCode: res.Data.ResponseData.ZipCode,
            StateId: String(res.Data.ResponseData.StateId),
            CountryId : String(res.Data.ResponseData.CountryId),
            City : res.Data.ResponseData.City,
            Landmark : res.Data.ResponseData.LandMark,
            UserId : res.Data.ResponseData.UserId,
            AddressId: res.Data.ResponseData.AddressId,
            //AddressType: res.Data.ResponseData.AddressType,
            Email : res.Data.ResponseData.Email
          });
        } else {
          this.notificationService.error('An error occured', 'Error');
          this.dialogRef.close();
        }
      }, (err: any) => {
        this.loader.hide();
        this.errorhandlerService.handleError(err);
      });
    }
}
